import * as React from 'react'
import {IconByKey} from '@oc/icons'
import {messages} from '../translations'

const textEditor = 'https://hmistudio.krones.com/'
const parameterReport = 'https://hmistudio.krones.com/parameterreport'
//const batchEditor = '' //TODO Fill and uncomment when link is available -- prepared for follow up story

export interface OcAppBarHmiStudioSubMenuAction {
    id: string
    ocIcon: JSX.Element
    text: string
    onClick: () => void
    disabled: boolean
}

export function getOcAppBarHmiStudioSubMenuActions(handleClose: () => void): OcAppBarHmiStudioSubMenuAction[] {
    return [
        {
            id: 'text-editor-link',
            ocIcon: <IconByKey iconKey="oc_text_field" size="32px" />,
            text: messages.getText('appBar', 'textEditor'),
            onClick: () => {
                window.open(textEditor, '_blank')
                handleClose()
            },
            disabled: false
        },
        {
            id: 'parameter-report-link',
            ocIcon: <IconByKey iconKey="oc_sp_reporting" size="32px" />,
            text: messages.getText('appBar', 'parameterReport'),
            onClick: () => {
                window.open(parameterReport, '_blank')
                handleClose()
            },
            disabled: false
        }
        //TODO Uncomment when link is available -- prepared for follow up story
        //{
        //    id: 'batch-editor-link',
        //    ocIcon: <IconByKey iconKey="theme-stack" size="32px" />,
        //    text: messages.getText('appBar', 'batchEditor'),
        //    disabled: false,
        //    onClick: () => {
        //        window.open(batchEditor, '_blank')
        //        handleClose()
        //    }
        //}
    ]
}
